import { Lock } from 'lucide-react';

const TIER_LABELS: Record<string, string> = {
  silver: 'Prata',
  gold: 'Ouro',
};

interface TierLockedOverlayProps {
  requiredTier: string;
  featureLabel: string;
  onUpgradeClick?: () => void;
}

export function TierLockedOverlay({ requiredTier, featureLabel, onUpgradeClick }: TierLockedOverlayProps) {
  const tierLabel = TIER_LABELS[requiredTier] ?? requiredTier;

  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-muted/30 px-8 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Lock className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold">
        {featureLabel}
      </h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        Disponível a partir do plano <span className="font-semibold">{tierLabel}</span>.
        Continue investindo em suas campanhas para desbloquear automaticamente,
        ou solicite um upgrade manual.
      </p>
      {onUpgradeClick && (
        <button
          onClick={onUpgradeClick}
          className="mt-4 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          Solicitar upgrade
        </button>
      )}
    </div>
  );
}
